/** YouTube embed — Error 153 önlemek için nocookie + origin + referrerPolicy */
export const YOUTUBE_EMBED_ORIGIN = 'https://www.proparcel.com';

export function buildYouTubeEmbedSrc(videoId, { autoplay = false } = {}) {
  const id = String(videoId || '').trim();
  if (!id) return '';

  const params = new URLSearchParams({
    origin: YOUTUBE_EMBED_ORIGIN,
    rel: '0',
    modestbranding: '1',
    playsinline: '1',
  });
  if (autoplay) params.set('autoplay', '1');

  return `https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?${params.toString()}`;
}

export function YouTubeEmbed({ videoId, title, autoplay = false, className = '' }) {
  const src = buildYouTubeEmbedSrc(videoId, { autoplay });
  if (!src) return null;

  return (
    <iframe
      class={className}
      src={src}
      title={title || 'YouTube video'}
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowFullScreen
      referrerPolicy="strict-origin-when-cross-origin"
    />
  );
}
